export * from './components/pop-under-with-router';

import { pop_under_with_router_state_provider } from './state';
import { ComponentProvider } from '@phi/vue-router';

export type IPopUnderWithRouter = ReturnType<typeof pop_under_with_router_provider>;

export const pop_under_with_router_provider = () => {
    const state = pop_under_with_router_state_provider();

    function show_pop_under(make_white: boolean) {
        if (make_white)
            state.pop_under_white.value = true;
        state.showing_pop_under.value = true;
    }

    function hide_pop_under() {
        console.log('Hide popunder');
        state.pop_under_white.value = false;
        state.showing_pop_under.value = false;
    }

    function goto(x: ComponentProvider) {
        state.route.value = x;
    }

    return {
        state,
        show_pop_under,
        hide_pop_under,
        goto,
    };
};
